import { Component, HostListener } from '@angular/core';
import { LiveChatService } from '@pages/services/live-chat.service';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat-support.component.html',
  styleUrls: ['./chat-support.component.scss'],
})
export class ChatSupportComponent {
  constructor(private readonly liveChatService: LiveChatService) {}
  private readonly mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  isMobile: boolean;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = this.detectMobileDevice();
  }

  openChat(): void {
    this.liveChatService.openLiveChat();
  }

  private detectMobileDevice(): boolean {
    return (
      this.mobileRegex.test(navigator.userAgent) || navigator.maxTouchPoints > 0
    );
  }
}
